export default "__VITE_ASSET__DXCI42f0__"